import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOmeMeetData from './GetOmeMeetData';
import getOmeMeetByMeetIdData from './GetOmeMeetByMeetIdData';
import postOmeMeetData from './PostOmeMeetData';
import putOmeMeetData from './PutOmeMeetData';
import getMeetSummaryData from './GetMeetSummaryData';
import getMeetSummaryForHostIdData from './GetMeetSummaryForHostIdData';
import getOmeMeetOrgUnitEntryPermissionData from './GetOmeMeetOrgUnitEntryPermissionData'
import deleteOmeMeetData from './DeleteOmeMeetData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  selectedMeet: {},
  route: ''
};

const OmeMeetData = {
  INITIAL_STATE,
  getOmeMeetData,
  getOmeMeetByMeetIdData,
  postOmeMeetData,
  putOmeMeetData,
  getMeetSummaryData,
  getMeetSummaryForHostIdData,
  getOmeMeetOrgUnitEntryPermissionData,
  deleteOmeMeetData
};

export default OmeMeetData;